import * as Eden from '@eden';
import { makeEdenAction } from './util/make-eden-action';
import { ResponseParseMethod } from './util/types';

/// TODO: Figure out a better way to organize these actions
/// TODO: Tests

export const login = makeEdenAction(Eden.RouteNames.POST_USER_AUTHENTICATE);

export const logInWithEmail = makeEdenAction(Eden.RouteNames.POST_USER_AUTHENTICATE);

export const loginWithMfa = makeEdenAction(Eden.RouteNames.POST_USER_AUTHENTICATE);

export const fetchTeamRelationshipsForTeam = makeEdenAction(Eden.RouteNames.GET_TEAM_RELATIONSHIPS);

export const fetchTeamUsersForTeam = makeEdenAction(Eden.RouteNames.GET_TEAM_USERS);

export const fetchPlayerAttributesForTeam = makeEdenAction(Eden.RouteNames.GET_PLAYERS);

export const putTeamManager = makeEdenAction(Eden.RouteNames.PUT_TEAM_MANAGER);

export const deleteTeamManager = makeEdenAction(Eden.RouteNames.DELETE_MANAGER);

export const fetchUserTeamAssociationsForTeam = makeEdenAction(Eden.RouteNames.GET_TEAM_ASSOCIATIONS);

export const fetchTeamFans = makeEdenAction(Eden.RouteNames.GET_TEAM_FANS);

export const postPlayer = makeEdenAction(Eden.RouteNames.POST_PLAYERS);

export const postBatsPlayer = makeEdenAction(Eden.RouteNames.POST_BATS_PLAYER_ATTRIBUTES);

export const patchPlayerFamilyRelationships = makeEdenAction(Eden.RouteNames.PATCH_PLAYER_FAMILY_RELATIONSHIPS);

export const patchPlayer = makeEdenAction(Eden.RouteNames.PATCH_PLAYER);

export const deletePlayer = makeEdenAction(Eden.RouteNames.DELETE_PLAYER);

export const patchBatsPlayer = makeEdenAction(Eden.RouteNames.PATCH_BATS_PLAYER_ATTRIBUTES);

export const postTeam = makeEdenAction(Eden.RouteNames.POST_TEAMS);

export const postMaxPrepTeamImport = makeEdenAction(Eden.RouteNames.POST_MAXPREPS_TEAM_IMPORT);

export const fetchTeam = makeEdenAction(Eden.RouteNames.GET_TEAM);

export const fetchCurrentUser = makeEdenAction(Eden.RouteNames.GET_ME_USER);

export const fetchSubscriptionInformation = makeEdenAction(Eden.RouteNames.GET_ME_SUBSCRIPTION_INFORMATION);

export const fetchTeamSchedule = makeEdenAction(Eden.RouteNames.GET_SCHEDULE_EVENTS);

export const fetchEvent = makeEdenAction(Eden.RouteNames.GET_EVENT);

export const fetchTeamGameSummaries = makeEdenAction(Eden.RouteNames.GET_TEAM_GAME_SUMMARIES);

export const fetchTeamAvatarImage = makeEdenAction(Eden.RouteNames.GET_TEAM_AVATAR_IMAGE);

export const postEvent = makeEdenAction(Eden.RouteNames.POST_SCHEDULE_EVENTS);

export const patchEvent = makeEdenAction(Eden.RouteNames.PATCH_SCHEDULE_EVENT);

export const patchEventSeries = makeEdenAction(Eden.RouteNames.PATCH_SCHEDULE_EVENT_SERIES);

export const postEventSeries = makeEdenAction(Eden.RouteNames.POST_SCHEDULE_EVENT_SERIES);

export const deleteEvent = makeEdenAction(Eden.RouteNames.DELETE_SCHEDULE_EVENT);

export const deleteEventSeries = makeEdenAction(Eden.RouteNames.DELETE_SCHEDULE_EVENT_SERIES);

export const fetchEventSeries = makeEdenAction(Eden.RouteNames.GET_SCHEDULE_EVENT_SERIES);

export const fetchEventRSVPs = makeEdenAction(Eden.RouteNames.GET_EVENT_RSVP);

export const putRSVPResponseForPlayer = makeEdenAction(Eden.RouteNames.PUT_EVENT_RSVP_FOR_PLAYER);

export const putRSVPResponseForUser = makeEdenAction(Eden.RouteNames.PUT_EVENT_RSVP_FOR_USER);

export const fetchEventVideoStream = makeEdenAction(Eden.RouteNames.GET_SCHEDULE_EVENT_VIDEO_STREAM);

export const fetchMeTeams = makeEdenAction(Eden.RouteNames.GET_ME_TEAM);

export const fetchMeTeamStats = makeEdenAction(Eden.RouteNames.GET_ME_TEAM_STATS);

export const fetchMeOrganizations = makeEdenAction(Eden.RouteNames.GET_ME_ORGANIZATIONS);

export const fetchPlayerStats = makeEdenAction(Eden.RouteNames.GET_PLAYER_STATS);

export const fetchPlayerGameStats = makeEdenAction(Eden.RouteNames.GET_PLAYER_GAME_STATS);

export const patchOpponent = makeEdenAction(Eden.RouteNames.PATCH_OPPONENT_TEAM);

export const postOpponent = makeEdenAction(Eden.RouteNames.POST_OPPONENT_TEAM);

export const opponentSearch = makeEdenAction(Eden.RouteNames.OPPONENT_SEARCH);

export const maxprepSearch = makeEdenAction(Eden.RouteNames.MAXPREPS_SCHOOL_SEARCH);

export const postOpponentTeamImport = makeEdenAction(Eden.RouteNames.POST_OPPONENT_TEAM_IMPORT);

export const postOpponentTeamLegacyImport = makeEdenAction(Eden.RouteNames.POST_OPPONENT_TEAM_LEGACY_IMPORT);

export const fetchEventBestStreamID = makeEdenAction(Eden.RouteNames.GET_EVENT_BEST_STREAM_ID);

export const fetchGameStream = makeEdenAction(Eden.RouteNames.GET_GAME_STREAM);

export const fetchGameStreamEvents = makeEdenAction(Eden.RouteNames.GET_GAME_STREAM_EVENTS);

export const fetchGameStreamViewerPayloadLite = makeEdenAction(Eden.RouteNames.GET_GAME_STREAM_VIEWER_PAYLOAD_LITE);

export const putGameStatEditCollection = makeEdenAction(Eden.RouteNames.PUT_GAME_STAT_EDIT_COLLECTION);

export const fetchGameStatEditCollection = makeEdenAction(Eden.RouteNames.GET_GAME_STAT_EDIT_COLLECTION);

export const fetchBatsStartingLineup = makeEdenAction(Eden.RouteNames.GET_BATS_STARTING_LINEUP);

export const postBatsStartingLineup = makeEdenAction(Eden.RouteNames.POST_BATS_STARTING_LINEUP);

export const patchBatsStartingLineup = makeEdenAction(Eden.RouteNames.PATCH_BATS_STARTING_LINEUP);

export const patchMePassword = makeEdenAction(Eden.RouteNames.PATCH_ME_PASSWORD);

export const patchTeamRollover = makeEdenAction(Eden.RouteNames.PATCH_ROSTER_ROLLOVER);

export const getPlayerProfilePhoto = makeEdenAction(
    Eden.RouteNames.GET_PLAYER_PROFILE_PHOTO,
    ResponseParseMethod.MANUAL,
);

export const fetchOrganization = makeEdenAction(Eden.RouteNames.GET_ORGANIZATION);

export const fetchOrgTeams = makeEdenAction(Eden.RouteNames.GET_ORGANIZATION_TEAMS);

export const fetchOrgUsers = makeEdenAction(Eden.RouteNames.GET_ORGANIZATION_USERS);

export const patchOrgEvent = makeEdenAction(Eden.RouteNames.PATCH_ORGANIZATION_SCHEDULE_EVENT);

export const postOrgEvent = makeEdenAction(Eden.RouteNames.POST_ORGANIZATION_SCHEDULE_EVENT);

export const postOrgEventBulk = makeEdenAction(Eden.RouteNames.POST_ORGANIZATION_SCHEDULE_EVENT_BULK);

export const getOrgEventBulkUploadTemplate = makeEdenAction(
    Eden.RouteNames.GET_ORGANIZATION_SCHEDULE_EVENT_BULK_UPLOAD_TEMPLATE,
);
export const postOrgEventBulkUploadValidate = makeEdenAction(
    Eden.RouteNames.POST_ORGANIZATION_SCHEDULE_EVENT_BULK_VALIDATE,
);

export const postOrgTeams = makeEdenAction(Eden.RouteNames.POST_ORGANIZATION_TEAMS);

export const getOrganizationLeaderboards = makeEdenAction(Eden.RouteNames.GET_ORGANIZATION_LEADERBOARDS);

export const getOrganizationResultsExport = makeEdenAction(
    Eden.RouteNames.GET_ORGANIZATION_SCHEDULE_EVENT_RESULTS_EXPORT,
);

export const getPlayerVideoClipsMetadata = makeEdenAction(Eden.RouteNames.GET_ALL_VIDEO_CLIP_METADATA_FOR_PLAYER);

export const getPlayerVideoClip = makeEdenAction(Eden.RouteNames.GET_VIDEO_CLIP);

export const getEventVideoClipsMetadata = makeEdenAction(
    Eden.RouteNames.GET_ALL_STREAM_ASSET_METADATA_FOR_SCHEDULE_EVENT,
);

export const getEventVideoClipsPlaybackData = makeEdenAction(Eden.RouteNames.GET_STREAM_ASSET_PLAYBACK_DATA);

export const getAllTeamStreamAssetMetadata = makeEdenAction(Eden.RouteNames.GET_ALL_TEAM_STREAM_ASSET_METADATA);

export const patchStreamAssetMetadata = makeEdenAction(Eden.RouteNames.PATCH_STREAM_ASSET_METADATA);

export const postTeamPass = makeEdenAction(Eden.RouteNames.POST_TEAM_COMMUNITY_PASS);

export const getOpponentTeams = makeEdenAction(Eden.RouteNames.GET_OPPONENT_TEAMS);

export const getOpponentTeam = makeEdenAction(Eden.RouteNames.GET_OPPONENT_TEAM);

export const getAthleteProfileByHandlePublic = makeEdenAction(
    Eden.RouteNames.GET_ATHLETE_PROFILE_BY_HANDLE_PUBLIC,
    ResponseParseMethod.MANUAL,
);

export const getAthleteProfileClipsPublic = makeEdenAction(Eden.RouteNames.GET_ATHLETE_PROFILE_CLIPS_PUBLIC);

export const getAthleteProfileAuthenticatedClipUrlPublic = makeEdenAction(
    Eden.RouteNames.GET_ATHLETE_PROFILE_AUTHENTICATED_CLIP_URL_PUBLIC,
);

export const getAthleteProfileCareerStatsPublic = makeEdenAction(
    Eden.RouteNames.GET_ATHLETE_PROFILE_CAREER_STATS_PUBLIC,
    ResponseParseMethod.MANUAL,
);

export const getTeamPublicProfileID = makeEdenAction(Eden.RouteNames.GET_TEAM_PUBLIC_PROFILE_ID);
